module.exports = __webpack_public_path__ + "static/media/step-7-id.b78c698a.jpg";